module.exports = __webpack_public_path__ + "videos/quickshape-cn.0fd1b98.mp4";